/**
 * Assertions should be stripped from production code.
 *
 * @internal
 */
export var Assert;
(function (Assert) {
    function inBetween(arg, min, max) {
        if (arg < min || arg > max) {
            throw new Error(`${arg} is not between ${min} and ${max}`);
        }
    }
    Assert.inBetween = inBetween;
    function defined(arg, msg) {
        if (!arg) {
            throw new Error(msg || `Argument should be defined. But was: ${arg}`);
        }
        return !!arg;
    }
    Assert.defined = defined;
    function notDefined(arg, msg) {
        if (arg) {
            throw new Error(msg || `Argument shouldn't be defined. But was: ${arg}`);
        }
    }
    Assert.notDefined = notDefined;
    /**
     * useful within switch-case statements to verify that all possible cases handled (e.g. no default cause is necessary).
     *
     * Usage:
     *   switch (data.jobType) {
     *     case JobType.APPLY_TASK_CONFIGURATION:
     *       return applyTaskConfiguration(e.data.value);
     *     case JobType.PROCESS_TASK:
     *       return processTask(e.data.value);
     *   }
     *
     *   return Assert.unreachable(data.jobType);
     */
    function unreachable(x) {
        throw new Error("Didn't expect to get here");
    }
    Assert.unreachable = unreachable;
})(Assert || (Assert = {}));
//# sourceMappingURL=Assert.js.map